import {
  FirestoreDataConverter,
  DocumentData,
  QueryDocumentSnapshot,
} from "firebase/firestore";
import { Release } from "./release";

export const releaseConverter: FirestoreDataConverter<Release> = {
  toFirestore(release: Release): DocumentData {
    // Remove version (it's the ID)
    const { version, ...releaseData } = release;
    return releaseData;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): Release {
    const data = snapshot.data() as Omit<Release, "version">;
    return {
      version: snapshot.id,
      ...data,
    };
  },
};